import React from 'react';
import './QuemSomos.scss';
import Grid from '@mui/material/Grid';
import Logo from '../../../assets/images/logo_grande.png'
import Container from '@mui/material/Container';

const QuemSomos = () => {

    return (
        <>
            <div className="view-quem-somos" id="quem-somos">
                <Container>
                    <Grid container spacing={0} columns={12} justifyContent="center" alignItems="center">
                        <Grid item lg={6}>
                            <div className="logo">
                                <img src={Logo} alt="" />
                            </div>
                        </Grid>
                        <Grid item lg={6}>
                            <div className="titulo">Quem Somos</div>
                            <div className="texto">
                            A Bupin é uma empresa de tecnologia especializada e focada no desenvolvimento de plataformas web e mobile. Buscamos em nossas soluções gerar experiencias diferentes no mercado, onde você possa controlar sua empresa de forma organizada e objetiva. Integramos ao seu negócio, agilidade e tecnologia, tornando sua empresa diferenciada e cada vez mais competitiva no mercado. Contamos também, com profissionais experientes e capacitados, prontos para atender as demandas de sua organização.
                            </div>
                        </Grid>
                    </Grid>
                </Container>
            </div>
        </>

    )
}

export default QuemSomos;